// extracted by css-extract-rspack-plugin
export default {"employerConstructorHideOnXs":"employer-constructor-hide-on-xs--rB3XERXWl4zdRfNt"};